<details-card [title]="title" [description]="description">
  <div actions>
    <button
      *ngIf="hasProductScopedWords && !hasNoWords && !allWordsHaveProductScope"
      qai-link
      class="header-action"
      [disabled]="hasErrors || isApiRequestInProgress()"
      (click)="onResetToProductDefault()"
    >
      Reset to product default
    </button>
    <button
      *ngIf="!hasNoWords && allWordsHaveProductScope"
      qai-link
      class="header-action"
      [disabled]="isApiRequestInProgress()"
      (click)="onDetachFromProductDefault()"
    >
      Detach from product default
    </button>
    <button
      *ngIf="!allWordsHaveProductScope"
      qai-link
      [disabled]="hasErrors || hasNoWords || isApiRequestInProgress()"
      class="header-action"
      (click)="saveAsProductDefault()"
    >
      Save as product default
    </button>
  </div>
  <div content class="content-container" *ngIf="sttWordsListControl">
    <qai-word-list
      [buttonText]="buttonText"
      [formControl]="sttWordsListControl"
      [getError]="getFieldError"
      [actionsDisabled]="hasErrors"
      (wordRemoved)="onWordRemoved($event)"
    >
      <button
        *ngIf="hasNoWords || !allWordsHaveProductScope"
        qai-link
        positionEnd
        class="header-action"
        [disabled]="hasNoWords || isGeneratingPrompt || isApiRequestInProgress()"
        (click)="onGenerateSttPrompt()"
      >
        <span *ngIf="isGeneratingPrompt">Generating...</span>
        <span *ngIf="!isGeneratingPrompt">Generate stt_prompt</span>
      </button>
    </qai-word-list>
  </div>
  <div *ngIf="showTextArea && sttPromptGroup && !hasNoWords" content class="textarea-container" [class.words-changed]="wordsListChanged">
    <qai-label [kind]="wordsListChanged ? 'warning' : 'secondary'" [size]="'medium'" [weight]="'bold'">
      stt_prompt
    </qai-label>
    <div [formGroup]="sttPromptGroup">
      <textarea
        qai-textarea
        autosize
        [maxLines]="30"
        formControlName="promptText"
      ></textarea>
    </div>
    <qai-label *ngIf="wordsListChanged" [kind]="'warning'" [size]="'small'" [weight]="'regular'" class="disclaimer-message">
      The word list has been updated since this prompt was generated. Regenerate to reflect the latest changes.
    </qai-label>
  </div>
</details-card>

<save-as-product-default-modal
  [open]="saveAsProductDefaultModalOpen"
  [moduleUuid]="moduleUuid"
  [keywordTitle]="keywordTitle"
  [networkRequestInProgress]="networkRequestInProgress"
  (confirm)="onSaveAsProductDefaultConfirm()"
  (closeModal)="onSaveAsProductDefaultModalClose()"
  (openChange)="saveAsProductDefaultModalOpen = $event"
></save-as-product-default-modal>

<dialog
  #errorDialog
  qai-dialog
  [description]="''"
  [heading]="'Cannot Save at Product Level'"
  (afterClose)="onErrorModalAfterClose()"
  (closeButtonClicked)="onErrorModalClose()"
>
  <div class="content">
    <span>The STT words and prompt cannot be saved at a product level. You can manually change other simulation STT config or reach out to your admin for help.</span>
  </div>

  <div class="modal-actions">
    <button
      qai-button
      kind="primary"
      size="medium"
      (click)="onErrorModalClose()"
    >
      OK
    </button>
  </div>
</dialog>
